import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M15.7131 12L9.70209 5.98999L8.28809 7.40399L12.8881 12.004L8.28809 16.597L9.70209 18.011L15.7131 12Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "ChevronRight"
);
